export const acceptableUsePolicy = [

  {
    id: 1,
    title: "1. Introduction",

    content: `
This Acceptable Use Policy ("Policy") defines the acceptable and
prohibited ways customers, administrators, employees and end users
may access and use Magyne ERP services.

The purpose of this Policy is to ensure that Magyne remains a secure,
reliable and trusted platform for all customers.

By using Magyne services, you agree to comply with this Policy.
`
  },


  {
    id: 2,
    title: "2. Scope of This Policy",

    content: `
This Policy applies to all users accessing Magyne services including:

• Business owners.

• Organization administrators.

• Employees.

• Teachers and school staff.

• Students and authorized users.

• Third-party users granted access by customers.

Customers are responsible for ensuring that all users under their
account comply with this Policy.
`
  },


  {
    id: 3,
    title: "3. Permitted Use",

    content: `
Magyne services may be used for legitimate business and
organizational purposes including:

• Managing business operations.

• Managing educational activities.

• Processing authorized transactions.

• Managing customer, employee or student information.

• Generating reports and business insights.

• Improving organizational efficiency.

Users must always use the platform responsibly and in accordance
with applicable laws.
`
  },


  {
    id: 4,
    title: "4. Prohibited Activities",

    content: `
Users must not use Magyne services to:

• Perform illegal activities.

• Store or distribute unlawful content.

• Violate privacy rights of individuals.

• Access information belonging to another organization.

• Attempt unauthorized system access.

• Circumvent security controls.

• Introduce viruses, malware or harmful code.

• Interfere with platform availability.

• Abuse system resources.
`
  },


  {
    id: 5,
    title: "5. Account Security Responsibilities",

    content: `
Users are responsible for protecting their account credentials.

Users must:

• Keep passwords confidential.

• Avoid sharing accounts.

• Use appropriate security practices.

• Immediately report unauthorized access.

• Maintain accurate account information.

Organizations are responsible for managing access permissions
for users within their accounts.
`
  },


  {
    id: 6,
    title: "6. Data Usage and Privacy",

    content: `
Users must only upload, process or store information that they
have legal authority to manage.

Users must not:

• Upload confidential information without authorization.

• Collect personal information unlawfully.

• Misuse customer, employee or student information.

• Attempt to access another organization's data.

Customers remain responsible for ensuring lawful use of information
stored within Magyne.
`
  },


  {
    id: 7,
    title: "7. Security Testing and Research",

    content: `
Users must not perform security testing, vulnerability scanning,
penetration testing or attempts to compromise Magyne systems without
written authorization.

Authorized security testing must follow approved procedures and
communication channels.
`
  },


  {
    id: 8,
    title: "8. System Abuse and Resource Limitations",

    content: `
Users must not abuse Magyne infrastructure by:

• Sending excessive automated requests.

• Attempting denial-of-service attacks.

• Consuming unreasonable system resources.

• Interfering with other customers' use of the platform.

Magyne may apply reasonable restrictions to protect platform
performance and reliability.
`
  },


  {
    id: 9,
    title: "9. Content Responsibility",

    content: `
Customers are responsible for all information and content uploaded
through their accounts.

Customers must ensure that stored information:

• Does not violate applicable laws.

• Does not infringe intellectual property rights.

• Does not contain malicious software.

• Does not harm other users.
`
  },


  {
    id: 10,
    title: "10. Intellectual Property Protection",

    content: `
Users must respect Magyne intellectual property.

Users must not:

• Copy or reproduce Magyne software.

• Reverse engineer the platform.

• Modify or redistribute Magyne applications.

• Remove ownership notices.

Access to Magyne services does not transfer ownership rights.
`
  },


  {
    id: 11,
    title: "11. Monitoring and Enforcement",

    content: `
Magyne may monitor platform usage to:

• Maintain security.

• Detect abuse.

• Investigate suspicious activities.

• Improve reliability.

Where violations occur, Magyne may take actions including:

• Warning the customer.

• Restricting access.

• Suspending accounts.

• Terminating services.
`
  },


  {
    id: 12,
    title: "12. Reporting Violations",

    content: `
Users are encouraged to report suspected security issues,
unauthorized access or violations of this Policy.

Reports should include enough information to allow Magyne to
investigate and respond appropriately.
`
  },


  {
    id: 13,
    title: "13. Customer Responsibilities",

    content: `
Customers are responsible for:

• Training users on appropriate platform usage.

• Managing user permissions.

• Removing access for inactive users.

• Ensuring compliance with organizational policies.

• Ensuring information uploaded to Magyne is lawful.
`
  },


  {
    id: 14,
    title: "14. Policy Updates",

    content: `
Magyne may update this Acceptable Use Policy as technology,
security practices and legal requirements change.

Updated versions will be published through official Magyne
communication channels.
`
  },


  {
    id: 15,
    title: "15. Contact Information",

    content: `
For questions regarding this Acceptable Use Policy or to report
potential violations, please contact Magyne ERP through
official support channels.

We are committed to maintaining a secure and respectful platform
for all users.
`
  }

];
